import {
  Box,
  Center,
  Heading,
  Text,
} from "@chakra-ui/react";
import LineSection from "../lineSection";
import SectionHeading from "./sectionHeading";
import Lang from "../../Lang";

export default function HeroHome() {
  return (
    <>
      <LineSection />
      <Box
        bgImage={"img/green-technology-background-creative-lighting-template-background-vector-illustration.webp"}
        backgroundSize={'cover'}
        backgroundPosition={'top'}
        color={"white"}
      >
        <Box className="opacityTop">
          <Heading
            as="h1"
            align={"center"}
            fontSize={{ base: "4em", md: "5em", lg: "6em", xl: "8em" }}
            pt={20}
            pb={{ base: "59vh", md: "72vh", xl: "65vh" }}
            className="barlow-black"
          >
            AI-SMALL BUSINESS
          </Heading>
        </Box>

        <Box className="opacityBottom">
          <Center>
            <Box
              w={{ base: "xl", md: "4xl", xl: "8xl" }}
            >
              <SectionHeading
                title="Objective"
              />
              <Text
                pb={20}
                px={{ base: 4, md: 6 }}
                fontSize={{ base: "1.5em", md: "3em", xl: "3em" }}
              >
                <Lang text="Our primary goal is to provide support to small businesses, enabling them to enhance their business model by optimizing one of their processes, harnessing the full potential of AI." />
                </Text>
            </Box>
          </Center>
        </Box>
      </Box>
    </>
  );
}